import { signal, Injectable } from '@angular/core';

import { RouteLayout } from './router-layout.types';

@Injectable({
  providedIn: 'root',
})
export class RouterLayoutService {
  private _layout = signal<RouteLayout | null>(null);

  layout = this._layout.asReadonly();

  setLayout(layout: RouteLayout): void {
    this._layout.set(layout);
  }
}
